import { useEffect } from "react";
import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo-dark.svg";

const AuthContainer = () => {
  const { route, user: authUser } = useAuthenticator((context) => [
    context.route,
    context.user,
  ]);

  const navigate = useNavigate();

  useEffect(() => {
    if (route === "authenticated" && authUser) {
      // Redirect to home page when user is authenticated
      navigate("/");
    }
  }, [route, authUser, navigate]);

  return (
    <div className="text-center">
      {route !== "authenticated" && (
        <img className="mt-25 mb-25 w-25" src={logo} alt="HCare360 Logo" />
      )}
      <Authenticator hideSignUp />
    </div>
  );
};

export default AuthContainer;
